import React, { useState, useRef, useLayoutEffect } from 'react';
import { LoadingButton } from '@one-thd/sui-atomic-components';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import RescheduleModal from './RescheduleModal';
import { getWindow } from '../../../utils/general';
import { getApiData, handleGuestUserReschedule, } from '../util/rescheduleDeliveryUtil';
import { useCommonContext } from '../../../hooks/useContexts';
export var RescheduleDelivery = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var buttonVariant = _a.buttonVariant, fulfillmentGroup = _a.fulfillmentGroup, fulfillmentType = _a.fulfillmentType, isDFSRescheduleEnabled = _a.isDFSRescheduleEnabled, orderDetailsData = _a.orderDetailsData, reschedule = _a.reschedule, setAvailableSlotsError = _a.setAvailableSlotsError, customerType = _a.customerType;
    var _j = useThdCustomer(), isLoggedIn = _j.isLoggedIn, isExchangeCustomer = _j.isExchangeCustomer;
    // For b2c all Reschedule Delivery is Secondary
    var _k = useState(false), open = _k[0], setOpen = _k[1];
    var _l = useState(false), loading = _l[0], setLoading = _l[1];
    var timezone = useCommonContext().timezone;
    var _m = useState(), availableSlotsData = _m[0], setAvailableSlotsData = _m[1];
    var firstUpdate = useRef(true);
    var handleDrawerClose = function (setRescheduleError, reload) {
        var _a;
        setOpen(false);
        setRescheduleError(false);
        if (reload) {
            (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location.reload();
        }
    };
    useLayoutEffect(function () {
        var _a, _b;
        if (firstUpdate.current) {
            firstUpdate.current = false;
            return;
        }
        (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage) === null || _b === void 0 ? void 0 : _b.removeItem('bannerState');
    });
    var deliveries = (_b = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.bodfsDeliveryAndHandling) === null || _b === void 0 ? void 0 : _b.bodfsDeliveries;
    var currentReservation = deliveries
        ? (_c = deliveries === null || deliveries === void 0 ? void 0 : deliveries[0]) === null || _c === void 0 ? void 0 : _c.reservationWindowDisplayText
        : undefined;
    var displayText = currentReservation
        ? (_d = currentReservation === null || currentReservation === void 0 ? void 0 : currentReservation.split(',')) === null || _d === void 0 ? void 0 : _d.join(' Between')
        : undefined;
    var getDayOfWeek = (deliveries === null || deliveries === void 0 ? void 0 : deliveries.length)
        ? new Date((_h = (_g = (_f = (_e = deliveries === null || deliveries === void 0 ? void 0 : deliveries[0]) === null || _e === void 0 ? void 0 : _e.reservationWindowEndTime) === null || _f === void 0 ? void 0 : _f.split('T')) === null || _g === void 0 ? void 0 : _g[0]) !== null && _h !== void 0 ? _h : '')
        : undefined;
    var dayOfWeek = getDayOfWeek
        ? new Intl.DateTimeFormat('en-US', {
            weekday: 'long',
        }).format(getDayOfWeek)
        : undefined;
    var deliveryDisplayText = dayOfWeek && displayText ? "".concat(dayOfWeek, ", ").concat(displayText) : undefined;
    return (React.createElement("div", { "data-testid": "rescheduleDelivery" },
        React.createElement(LoadingButton, { variant: buttonVariant, onClick: function () {
                if (isLoggedIn && !isExchangeCustomer) {
                    getApiData(orderDetailsData, fulfillmentGroup, setAvailableSlotsData, setOpen, setLoading, setAvailableSlotsError);
                }
                else {
                    handleGuestUserReschedule(orderDetailsData, fulfillmentGroup, setAvailableSlotsData, setOpen, setLoading, setAvailableSlotsError, timezone);
                }
            }, loading: loading, style: { width: '100%' } }, "Reschedule Delivery"),
        availableSlotsData && (React.createElement(RescheduleModal, { open: open, handleClose: handleDrawerClose, orderDetailsData: orderDetailsData, fulfillmentGroup: fulfillmentGroup, availableSlotsData: availableSlotsData, reschedule: reschedule, isDFSRescheduleEnabled: isDFSRescheduleEnabled, fulfillmentType: fulfillmentType, setAvailableSlotsError: setAvailableSlotsError, setOpen: setOpen, currentReservation: currentReservation, deliveryDisplayText: deliveryDisplayText, customerType: customerType }))));
};
